<template>
  <video id="bg-video" poster="/static/tngscreen.jpg" playsinline autoplay muted loop>
    <source src="/static/worf-screen.mp4" type="video/mp4">
  </video>
</template>

<script>
export default {
  name: 'bg-video'
};
</script>

<style>
#bg-video {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  /*transition: 1s opacity;*/
  z-index: -100;
}

@media screen and (max-aspect-ratio:4/3) {
  #bg-video {
    width: auto;
    height: 100%;
  }
}

@media screen and (min-aspect-ratio:4/3) {
  #bg-video {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// BgVideo.vue?7a985b8a